import styled from 'styled-components';

export type DropdownWrapperProps = {
  width?: number;
  disabled?: boolean;
  borderRadius?: number;
  flexDirection?: string;
  isMobileDevice?: boolean;
};

export const DropdownWrapper = styled.span<DropdownWrapperProps>`
  width: ${(props) => (props.width ? `${props.width}px` : `100%`)};
  background-color: ${(props) => props.theme.palette.white};
  display: flex;
  flex-direction: ${(props) => props.flexDirection ?? `column`};
  border-radius: ${(props) => props.borderRadius ?? 5}px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  position: relative;
  cursor: pointer;
  font-size: ${(props) => props.theme.typography.h5}px;
  pointer-events: ${(props) => (props.disabled ? `none` : `auto`)};
  ${(props) => props.disabled && `filter: grayscale(100%) opacity(30%);`};
  ${(props) => props.disabled && `pointer-events: none`};

  &.label-type {
    background-color: inherit;
    box-shadow: none;
    .header-text {
      color: ${(props) => props.theme.palette.vibrantPurple};
      text-decoration-line: underline;
    }
    .header-filter-value {
      line-height: 1;
      font-weight: ${(props) => props.theme.typography.fontWeights.light};
    }
  }
  &.react-table-header-range {
    background-color: inherit;
    border-radius: 0px;
    box-shadow: none;
    .header-text {
      color: ${(props) => props.theme.palette.vibrantPurple};
      text-decoration-line: underline;
    }
    .header-filter-value {
      line-height: 1;
      font-weight: ${(props) => props.theme.typography.fontWeights.light};
    }

    .numeric-field {
      padding-right: 8px;
      margin-left: 6px;
      .form-label {
        margin-right: 46px;
      }
    }
  }
  &.responsive-adjust {
    margin-bottom: ${(props) => (props.isMobileDevice ? '10px' : '5%')};
    justify-content: ${(props) => (props.isMobileDevice ? 'space-around' : '')};
  }
`;
